let ipcRenderer = null;

try {
  if (window && window.require) {
    const electron = window.require("electron");
    ipcRenderer = electron.ipcRenderer;
    console.log("✅ Electron ipcRenderer loaded");
  } else {
    console.log("ℹ️ Running in browser, ipcRenderer not available");
  }
} catch (err) {
  console.log("⚠️ ipcRenderer not available:", err.message);
}

export const IpcHelper = ipcRenderer;

export default {
  install(Vue) {
    Vue.prototype.$ipcRenderer = ipcRenderer;
  }
};



// WEBPACK FOOTER //
// ./src/plugins/electron-ipc.js